const BASE_URL = process.env.REACT_APP_FRONT_URL
const BACK_URL = process.env.REACT_APP_BACKEND_URL

const USERS_URL = `${BASE_URL}users.json`
const BACK_USERS_URL = `${BACK_URL}users/`
const BACK_USERS_PROFILE_URL = `${BACK_URL}userprofiles/`
const ORGANIZATION_USERS_URL = `${BACK_URL}organizations/users`
const REPORT_ASSIGNS = `${BACK_URL}reportassigns/`
const VICTIMS = `${BACK_URL}victims/`
const SUBJECTS = `${BACK_URL}subjects/`
const REPORTING_PARTIES = `${BACK_URL}reportingparties/`
const PRESETS = `${BACK_URL}presets`

export default {
  USERS_URL,
  BACK_USERS_URL,
  ORGANIZATION_USERS_URL,
  REPORT_ASSIGNS,
  VICTIMS,
  SUBJECTS,
  REPORTING_PARTIES,
  PRESETS,
  BACK_USERS_PROFILE_URL,
}
